/* eslint-disable max-len */

export const PAGE_INFO_LOADED_SUCCESS = 'product/PAGE_INFO_LOADED_SUCCESS';
export const PAGE_INFO_LOADED_ERROR = 'product/PAGE_INFO_LOADED_ERROR';
export const pageDataLoaded = (payload: any) => ({ payload, type: PAGE_INFO_LOADED_SUCCESS });
